import { render, staticRenderFns } from "./IconReceiptTaxOutline.vue?vue&type=template&id=e749e2c6"
import script from "./IconReceiptTaxOutline.vue?vue&type=script&lang=js"
export * from "./IconReceiptTaxOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports